import type { ExtendConfig } from '@udecode/plate';
import { toPlatePlugin, toTPlatePlugin } from '@udecode/plate/react';

import type { TCitationElement } from '../lib';
import { type BaseCitationConfig,BaseCitationInputPlugin,BaseCitationPlugin } from '../lib/BaseCitationPlugin';

export type EditCitationCallback = () => void;

export type CitationConfig = ExtendConfig<
  BaseCitationConfig,
  {
    isEditing: boolean;
    mouseDown: boolean;
    openEditorId: string | null;
    updated: boolean;
    pageNumber: string;
    editCitationCallback?: EditCitationCallback;
    pageNumberPrefix: string;
  },
  {
    floatingCitation: {
      hide: () => void;
      reset: () => void;
      show: (editorId: string, element: TCitationElement, editCallback?: EditCitationCallback) => void;
    }
  },
  {},
  {
    isOpen?: (editorId: string) => boolean;
  }
>;

export const CitationPlugin = toTPlatePlugin<CitationConfig>(BaseCitationPlugin, {
    options: {
        isEditing: false,
        mouseDown: false,
        openEditorId: null,
        updated: false,
        pageNumber: '',
        editCitationCallback: undefined,
        pageNumberPrefix: 's. '
    },
})
    .extendEditorApi<Partial<CitationConfig['api']>>(({ setOptions }) => ({
        floatingCitation: {
            hide: () => {
                setOptions({
                    isEditing: false,
                    mouseDown: false,
                    openEditorId: null,
                    updated: false,
                    pageNumber: '',
                });
            },
            reset: () => {
                setOptions({
                    isEditing: false,
                    mouseDown: false,
                    updated: false,
                    pageNumber: '',
                });
            },
            show: (editorId: string, element: TCitationElement, editCallback?: EditCitationCallback) => {
                setOptions({
                    isEditing: false,
                    openEditorId: editorId,
                    pageNumber: element.pageNumber ?? '',
                    editCitationCallback: editCallback,
                });
            },
        },
    }))
    .extendSelectors<CitationConfig['selectors']>(({ getOptions }) => ({
        isOpen: (editorId) => getOptions().openEditorId === editorId,
    }));

export const CitationInputPlugin = toPlatePlugin(BaseCitationInputPlugin);
